import templateUrl from './acknowledged-modified-time-entry-audit-log.component.html'
import { AuditLogHistoryEntryModal } from './audit-log-entry-history-modal.component';

export const AcknowledgedModifiedTimeEntryAuditLogComponent = {
    controller: AcknowledgedModifiedTimeEntryAuditLogController,
    controllerAs: "vm",
    templateUrl
}

function AcknowledgedModifiedTimeEntryAuditLogController($uibModal, $q, auditLogService, utilityService) {
    'ngInject';
    const vm = this;
    vm.auditLogs;
    vm.selectedAuditLog;
    vm.employeeLimit = 25;

    vm.$onInit = $onInit;
    vm.onSelectAuditLog = onSelectAuditLog;
    vm.onViewHistory = onViewHistory;

    function $onInit() {
        utilityService.showLoading();
        auditLogService.retrieveAcknowledgedModifiedTimeEntryAuditLogs()
            .then(function (auditLogs) {
                auditLogs.forEach(function (auditLog) {
                    const employee = auditLog.Employee;
                    auditLog.SearchText = (employee.FirstName || "") + " " + (employee.LastName || "")
                        + (employee.ICDName || "") + employee.EmailAddress;
                });
                vm.auditLogs = auditLogs;
            })
            .catch(function (ex) {
                console.error(ex);
            })
            .then(utilityService.hideLoading);
    }

    function onSelectAuditLog(auditLog) {
        utilityService.showLoading();
        loadAuditLogEntries(auditLog)
            .then(function (auditLog) {
                vm.selectedAuditLog = auditLog;
            })
            .catch(function (ex) {
                console.error(ex);
            })
            .then(utilityService.hideLoading);
    }


    function onViewHistory(timeEntry) {
        // Open a modal to display the time entry history.
        $uibModal.open({
            ...AuditLogHistoryEntryModal,
            resolve: {
                auditLogEntry: () => timeEntry,
                title: () => "Changes to Time Entry"
            }
        });
    }

    function loadAuditLogEntries(auditLog) {
        if (auditLog.Modifications) {
            return $q.when(auditLog);
        }
        return auditLogService.retrieveAcknowledgedModifiedTimeEntryAuditLog(auditLog.Employee.Id)
            .then(function (auditLogEntries) {
                if (auditLogEntries === null) {
                    auditLog.Modifications = [];
                } else {
                    auditLog.Modifications = auditLogEntries.Modifications;
                }
                return auditLog;
            });
    }
}
